import styled from "styled-components";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Icon } from "@sablier/v2-components/molecules";
import { tags } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useFieldStreams } from "../../logic";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    justify-content: center;
    width: 100%;
  }
`;

const Button = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    column-gap: ${(props) => props.theme.sizes.edge};
    cursor: pointer;
    opacity: 0.7;
    &:hover,
    &:active {
      opacity: 1;
    }
  }
`;

const Box = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    justify-content: center;
    width: 54px;
    height: 54px;
    border: 2px solid ${(props) => props.theme.colors.gray500};
    border-radius: 16px;
    svg {
      color: ${(props) => props.theme.colors.gray400};
    }
  }
`;

const Title = styled.div`
  & > p {
    ${(props) => props.theme.styles.textButton}
    & {
      color: ${(props) => props.theme.colors.gray400};
    }
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    padding-top: calc(${(props) => props.theme.sizes.edge} * 1);
    padding-bottom: calc(${(props) => props.theme.sizes.edge} * 1);
  }
`;

interface Props {
  onClick?: () => void;
}

function Action({ onClick }: Props) {
  const { onAdd } = useFieldStreams();
  const { t } = useT();

  return (
    <Wrapper onClick={onClick}>
      <Button data-cy={tags.actionAddStream} onClick={onAdd}>
        <Box>
          <Icon value={PlusIcon} />
        </Box>
        <Title>
          <p>{t("structs.addNewStream")}</p>
        </Title>
      </Button>
    </Wrapper>
  );
}

export default Action;
